import { Button } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  position: absolute;
  right: 0;
  bottom: 100%;
`;
